'use client';
import { useUnit } from "effector-react";
import {
  DrawerRoot, DrawerContent, DrawerBody, DrawerCloseTrigger,
  DrawerBackdrop,
  DrawerHeader,
} from "@/components/ui/drawer";
import { $isDrawerOpen, $drawerTab, $drawerType, closeDrawer, openDrawer, $drawerContent, $drawerTitle } from "@/shared/store/drawer";
import { Badge, Circle, Flex, HStack, Separator, Text } from "@chakra-ui/react";
import Cart from "../shop/Cart";
import Menu from "./Menu";
import CitySelectorMenu from "../custom/CitySelectorMenu";
import LanguageSwitcherMenu from "../custom/LanguageSwitcherMenu";
import Favorites from "../shop/Favorites";
import { Button } from "../ui/button";
import { $shopState } from "@/shared/store/shop";
import { useEffect } from "react";
import { usePathname } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

export default function GlobalDrawer() {
  const t = useTranslations();
  const pathname = usePathname();
  const isOpen = useUnit($isDrawerOpen);
  const type = useUnit($drawerType);
  const tab = useUnit($drawerTab);
  const title = useUnit($drawerTitle);
  const content = useUnit($drawerContent);

  const { cart, favorites } = useUnit($shopState);

  useEffect(() => {
    // Закрываем дровер при смене страницы
    closeDrawer();
  }, [pathname]);

  return (
    <DrawerRoot open={isOpen} onOpenChange={() => closeDrawer()} size={{ base: "xs", md: "md" }}>
      <DrawerBackdrop />
      <DrawerContent minW={"372px"}>
        {/* CUSTOM */}
        {
          type === "custom" ?
            <DrawerHeader px={{ base: "16px", md: "40px" }} pt={{ base: "54px", md: "26px" }} pb={0} mb={"15px"}>
              <Flex gap={4} align="center" w="100%">
                {title}
                {/* Эта кнопка всегда справа */}
                <DrawerCloseTrigger absolute={false} ml="auto" />
              </Flex>
            </DrawerHeader>
            :
            <DrawerHeader px={{ base: "16px", md: "40px" }} pt={{ base: "54px", md: "26px" }} pb={0} mb={{ base: "12px", md: "16px" }}>
              <Flex gap={4} align="center" w="100%">
                {type === "main" && (
                  <HStack gap={4}>
                    <Button
                      p={0}
                      variant={"plain"}
                      onClick={() => openDrawer({ type: "main", tab: "cart" })}
                      textStyle={"bold16"}
                      color={tab === "cart" ? undefined : "text.secondary"}
                    >
                      {t('cart')} {cart.count > 0 && <Circle textStyle={"bold12"} size={"6"} borderRadius={"full"} bg={"bg.subtle"}>{cart.count}</Circle>}
                    </Button>
                    <Button
                      p={0}
                      variant={"plain"}
                      onClick={() => openDrawer({ type: "main", tab: "favorites" })}
                      textStyle={"bold16"}
                      color={tab === "favorites" ? undefined : "text.secondary"}
                    >
                      {t('favorites')}
                    </Button>
                  </HStack>
                )}
                {type === "menu" && (
                  <HStack gap="22px">
                    <LanguageSwitcherMenu />
                    <CitySelectorMenu />
                  </HStack>
                )}
                {/* Эта кнопка всегда справа */}
                <DrawerCloseTrigger absolute={false} ml="auto" />
              </Flex>
            </DrawerHeader>
        }
        {
          type === "custom" ?
            <DrawerBody px={{ base: "16px", md: "40px" }} py={0}>{content && (content)}</DrawerBody>
            :
            <DrawerBody px={(type === "main" && tab === "cart") ? 0 : { base: "16px", md: "40px" }} py={0} pb={(type === "main" && tab === "cart") ? 0 : "128px"}>
              { tab !== "cart" && <Separator pb={{ base: "20px", md: "38px" }} borderColor={"stroke"} />}
              {type === "main" && tab === "cart" && <Cart />}
              {type === "main" && tab === "favorites" && <Favorites />}
              {type === "menu" && (
                <Menu />
              )}
            </DrawerBody>
        }
      </DrawerContent>
    </DrawerRoot>
  );
}